<div class="skeletor-create-supplier">
  <div class="skeletor-header">
    <div class="skeletor-header-icon">
      <p-skeleton shape="circle" [width]="'2.25rem'" [height]="'2.25rem'"></p-skeleton>
    </div>
    <div class="skeletor-header-text">
      <p-skeleton [width]="'12rem'" [height]="'1.3rem'"></p-skeleton>
      <p-skeleton [width]="'18rem'" [height]="'1rem'"></p-skeleton>
    </div>
  </div>

  <div class="skeletor-invitation-card">
    <div class="skeletor-invitation-header">
      <div class="skeletor-invitation-title">
        <p-skeleton [width]="'10rem'" [height]="'1.1rem'"></p-skeleton>
        <p-skeleton [width]="'12rem'" [height]="'0.9rem'"></p-skeleton>
      </div>
      <div class="skeletor-invitation-toggle">
        <p-skeleton shape="circle" [width]="'2.5rem'" [height]="'1.4rem'"></p-skeleton>
        <p-skeleton [width]="'10rem'" [height]="'0.9rem'"></p-skeleton>
      </div>
    </div>
    <div class="skeletor-invitation-body">
      <div class="skeletor-field">
        <p-skeleton [width]="'7rem'" [height]="'0.9rem'"></p-skeleton>
        <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
      </div>
      <div class="skeletor-field">
        <p-skeleton [width]="'8rem'" [height]="'0.9rem'"></p-skeleton>
        <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
      </div>
    </div>
    <div class="skeletor-invitation-actions">
      <p-skeleton [width]="'10rem'" [height]="'2.3rem'"></p-skeleton>
    </div>
  </div>

  <div class="skeletor-main">
    <div class="skeletor-card">
      <div class="skeletor-card-header">
        <p-skeleton [width]="'14rem'" [height]="'1.1rem'"></p-skeleton>
      </div>
      <div class="skeletor-card-body">
        <div class="skeletor-grid-two">
          <div class="skeletor-field">
            <p-skeleton [width]="'4rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'6rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field full">
            <p-skeleton [width]="'7rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'5rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'60%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'8rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'70%'" [height]="'2.2rem'"></p-skeleton>
          </div>
        </div>
        <div class="skeletor-field skeletor-select">
          <p-skeleton [width]="'6rem'" [height]="'0.9rem'"></p-skeleton>
          <p-skeleton [width]="'45%'" [height]="'2.2rem'"></p-skeleton>
        </div>
      </div>
    </div>

    <div class="skeletor-card">
      <div class="skeletor-card-header">
        <p-skeleton [width]="'12rem'" [height]="'1.1rem'"></p-skeleton>
      </div>
      <div class="skeletor-card-body">
        <div class="skeletor-grid-two">
          <div class="skeletor-field">
            <p-skeleton [width]="'5rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'5rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'70%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'4rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'65%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'5rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'60%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'4rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'80%'" [height]="'2.2rem'"></p-skeleton>
          </div>
        </div>
        <div class="skeletor-field full">
          <p-skeleton [width]="'8rem'" [height]="'0.9rem'"></p-skeleton>
          <p-skeleton [width]="'100%'" [height]="'4rem'"></p-skeleton>
        </div>
        <div class="skeletor-grid-three">
          <div class="skeletor-field">
            <p-skeleton [width]="'4rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'6rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
          <div class="skeletor-field">
            <p-skeleton [width]="'8rem'" [height]="'0.9rem'"></p-skeleton>
            <p-skeleton [width]="'100%'" [height]="'2.2rem'"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    
  </div>

  <div class="skeletor-actions">
    <p-skeleton [width]="'11rem'" [height]="'2.5rem'"></p-skeleton>
  </div>
</div>
